import { Box } from '@mui/material';
import { TextFieldStyled } from '../../shared/styles';
import { Dropdown } from '../../shared/dropdown/dropdown';
import { typeTransactions } from '../mockedData';
import { Button } from '../../shared/button/button';

export const FiltersTransactions = ({
  filters,
  setFilters,
  handleGetTransactions,
  credentialId,
}) => {
  function handleSelectTransactionType(value) {
    setFilters({ ...filters, transactionType: value });
  }

  return (
    <Box display={'flex'} gap={'8px'} alignItems={'center'} mt={'16px'}>
      <Dropdown
        label={'Transaction type'}
        withSearch={false}
        options={typeTransactions}
        width={'180px'}
        defaultValue={filters.transactionType}
        onSelect={handleSelectTransactionType}
      />
      {filters?.transactionType === 'Tenui' && (
        <Box display={'flex'} gap={'8px'} position={'relative'}>
          <TextFieldStyled
            name={'transactionId'}
            placeholder={'Transaction number'}
            type={'text'}
            variant="standard"
            InputProps={{
              disableUnderline: true,
              endAdornment: filters?.transactionNumber && (
                <Button
                  onClick={() => {
                    const newFilters = { ...filters, transactionNumber: '' };
                    setFilters(newFilters);
                    handleGetTransactions(newFilters, credentialId);
                  }}
                  startIcon={'X'}
                  type={'regular'}
                  containerStyles={{
                    position: 'absolute',
                    right: '8px',
                  }}
                />
              ),
            }}
            sx={{ width: '160px' }}
            value={filters.transactionNumber}
            onChange={(e) =>
              setFilters({ ...filters, transactionNumber: e.target.value })
            }
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleGetTransactions(null, credentialId);
              }
            }}
          />
          <Button
            label={'Search'}
            onClick={() => handleGetTransactions(null, credentialId)}
          />
        </Box>
      )}
    </Box>
  );
};
